import React from 'react'
import PropTypes from 'prop-types'
import { injectIntl, FormattedMessage } from 'react-intl'

const MineDisputedTab = ({ disputedInfo, user, setVoteQuestion }) => (
  <React.Fragment>
    {disputedInfo.length > 0 ? (
      disputedInfo.map((dispute) => {
        return (
          <div
            onClick={() => setVoteQuestion({ ...dispute, onlyView: true })}
            key={dispute.id}
            className="mars--challenges__info--item mine"
          >
            <div className={dispute.right ? 'icons success' : 'icons failed'}>
              <span className={dispute.right ? 'icon-badge' : 'icon-dislike'}></span>
            </div>
            {user.id == dispute.createdBy ? (
              <span className="icon-self-question orange"></span>
            ) : null}
            <span className="text text--ellipsis">{dispute.question}</span>
            <span className={dispute.right ? 'result' : 'result failed'}>
              {dispute.currency2 && dispute.currency2 != dispute.currency && (
                <span>
                  {dispute.reward}{' '}
                  <span
                    className={`icon-${dispute.currency2 == 'antimatter' ? 'antimateria' : 'coin'}`}
                  />
                </span>
              )}
              <span>
                {dispute.reward}{' '}
                <span
                  className={`icon-${dispute.currency == 'antimatter' ? 'antimateria' : 'coin'}`}
                />
              </span>
              <span>
                {dispute.right ? (
                  <FormattedMessage id="phase.mineTab.won" />
                ) : (
                  <FormattedMessage id="phase.mineTab.lost" />
                )}
              </span>
            </span>
          </div>
        )
      })
    ) : (
      <div>
        <span className="text">
          <FormattedMessage id="phase.informationPhase_No_Debate" />
        </span>
      </div>
    )}
  </React.Fragment>
)

MineDisputedTab.propTypes = {
  setVoteQuestion: PropTypes.func,
  disputedInfo: PropTypes.array,
  user: PropTypes.object,
}

export default injectIntl(MineDisputedTab)
